import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { NavBarContent } from 'feature/nav/NavBar';
import ReportTabs from '../Tabs';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { get, set } from 'global/lib/lodash';
import realmChange from 'global/wrappers/realmChange';
import PermissionGate from 'global/components/permission-gate';
import { useUser } from 'global/hooks/useUser';

const AssessmentIncludes = ['realm', 'realm.realms', 'realm.parent', 'scorecards', 'scorecards.edition', 'scorecards.edition.documents', 'scorecards.edition.realm', 'authors', 'editors', 'viewers', 'assignees', 'media', 'lockedBy'];

const PScoreIncludes = 'checklist';
const include = AssessmentIncludes.join(',');

function ReportAssessment(props) {
  const { match } = props;
  const { me } = useUser();
  const assessment = useRetrieveData({ url: `/assessment-templates/${match.params.id}` }, { build: ['assessments'], transformData: (d) => d[0], params: { include } });
  const highlights = useRetrieveData(
    { url: '/report-sections' },
    { build: ['reportSections'], params: { include: 'superset,images,realm,origin,user,assessment,origin.superset,origin.images,progeny', filter: { assessment_id: match.params.id } } }
  );
  const scores = useRetrieveData(
    {
      url: '/processed-scorecard-score-values',
    },
    {
      build: ['processedScorecardScoreValues'],
      params: {
        filter: { assessment_id: match.params.id },
        include: PScoreIncludes,
      },
      transformData: (d) => {
        const scdata = {};
        d.map((di) => {
          set(scdata, di.scorecardId, [...get(scdata, di.scorecardId, []), di]);
        });
        return scdata;
      },
    }
  );

  const { data, loading } = assessment;

  const userCanEdit = (() => {
    if (loading) {
      return false;
    }
    const { editors, authors } = data;
    const isEditor = (editors || []).find((e) => e.id == me.id);
    const isAuthor = (authors || []).find((e) => e.id == me.id);
    return isEditor || isAuthor;
  })();

  const status = get(assessment, 'data.status', 'draft');

  const canShowScores = (() => {
    if (userCanEdit) {
      return true;
    }
    if (status === 'review') {
      return userCanEdit || get(assessment, 'data.viewers', []).find((v) => v.id == me.id);
    } else if (status === 'published') {
      return true;
    } else if (status.indexOf('template') > -1) {
      return true;
    } else {
      return false;
    }
  })();

  const toLink = get(props, 'location.state.from', 'reports/list');

  const isTemplate = true;

  return (
    <>
      {data && <NavBarContent space={true} pageTitle={data.name} link={toLink} />}
      <Switch>
        <Route
          exact
          path="/reports/assessment-template/:id"
          render={(props) => (
            <ReportTabs page={match.url} assessment={assessment} isTemplate={isTemplate} highlights={highlights} userCanEdit={userCanEdit} canShowScores={canShowScores} currentTabValue="info" />
          )}
        />
        <Route
          exact
          path="/reports/assessment-template/:id/info"
          render={(props) => (
            <ReportTabs page={match.url} assessment={assessment} isTemplate={isTemplate} highlights={highlights} userCanEdit={userCanEdit} canShowScores={canShowScores} currentTabValue="info" />
          )}
        />
        <Route
          exact
          path="/reports/assessment-template/:id/scores"
          render={(props) => (
            <ReportTabs
              page={match.url}
              assessment={assessment}
              isTemplate={isTemplate}
              scores={scores}
              highlights={highlights}
              userCanEdit={userCanEdit}
              canShowScores={canShowScores}
              currentTabValue="scores"
            />
          )}
        />
        <Route
          exact
          path="/reports/assessment-template/:id/highlights"
          render={(props) => (
            <ReportTabs page={match.url} assessment={assessment} isTemplate={isTemplate} highlights={highlights} userCanEdit={userCanEdit} canShowScores={canShowScores} currentTabValue="highlights" />
          )}
        />
        {/* <Route exact path="/reports/assessment-template/:id/photos" render={(props) => <ReportTabs page={match.url} assessment={assessment} isTemplate={isTemplate} highlights={highlights} userCanEdit={userCanEdit} canShowScores={canShowScores} assessmentId={match.params.id} currentTabValue="photos" />} /> */}
      </Switch>
    </>
  );
}

export default PermissionGate(realmChange(ReportAssessment));
